// Find class objects in a list by their string value
export function findClassByValue(classOptions, value) {
    if (!Array.isArray(classOptions)) return undefined;
    return classOptions.find((r) => r.value === value);
}

// Find legal status objects in a list by their numeric value
export function findLegalStatusByValue(roleOptions, value) {
    if (!Array.isArray(roleOptions)) return undefined;
    return roleOptions.find((r) => r.value === Number(value));
}

// Find load status objects in a list by their string value
export function findLoadStatusValue(loadStatusOptions, value) {
    if (!Array.isArray(loadStatusOptions)) return undefined;
    return loadStatusOptions.find((r) => r.value === value);
}

// Clean and normalize the Product filter object for API requests
export function cleanProductFilter(filter, productRange, productSort) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .map(([k, v]) => [
                k,
                (['classFilter', 'legalStatusId', 'loadStatus'].includes(k) && v && typeof v === 'object')
                    ? v.value ?? v.id ?? ''
                    : v,
            ])
            .filter(([_, v]) => v != null && v !== ''),
    );
    if (productRange) filtered.productRange = productRange;
    if (productSort) filtered.productSort = productSort;
    return filtered;
}